import { MonthDropdownValues } from '../../utils/enums';
import { copyFor } from '../../copy/copy';

export const buildMapsUrl = (
    address1 = '',
    address2 = '',
    city = '',
    state = '',
    zip = ''
) => {
    const baseURL = `https://www.google.com/maps/search/?api=1&query=`;
    const paramsString = [address1, address2, city, state, zip]
        .join(' ')
        .replace(/ /g, '+');
    return baseURL + paramsString;
};

export const buildDateRange = ({ startDate, endDate, singleDayOpportunity, onGoing }) => {
    if (onGoing) return copyFor('opportunity', 'ongoing', 'volunteer');
    if (startDate === undefined || endDate === undefined)
        return copyFor('opportunity', 'flexibleDates', 'volunteer');

    const s = new Date(startDate);
    const start = {
        day: s.getUTCDate(),
        month: MonthDropdownValues[s.getMonth()],
        year: s.getUTCFullYear()
    };

    if (singleDayOpportunity) {
        return `${start.month} ${start.day}, ${start.year}`;
    } else {
        const e = new Date(endDate);
        const end = {
            day: e.getUTCDate(),
            month: MonthDropdownValues[e.getMonth()],
            year: e.getUTCFullYear()
        };
        return `${start.month} ${start.day}, ${start.year} - ${end.month} ${end.day}, ${
            end.year
        }`;
    }
};

export const buildTimeRange = ({ startDate, endDate }) => {
    if (startDate === undefined || endDate === undefined) return;
    if (startDate === endDate) return '';
    const startDateUTC = new Date(startDate);
    const endDateUTC = new Date(endDate);

    let startDT = new Date();
    startDT.setHours(startDateUTC.getUTCHours());
    startDT.setMinutes(startDateUTC.getUTCMinutes());

    let endDT = new Date();
    endDT.setHours(endDateUTC.getUTCHours());
    endDT.setMinutes(endDateUTC.getUTCMinutes());

    const s = new Date(startDT).toLocaleString('en-US', {
        hour: 'numeric',
        minute: 'numeric',
        hour12: 'true'
    });

    const e = new Date(endDT).toLocaleString('en-US', {
        hour: 'numeric',
        minute: 'numeric',
        hour12: 'true'
    });

    return `${s} - ${e}`;
};
